<template>
  <el-dialog title="选择提货订单" :visible="visible" width="900px" @close="handleClose">
    <div class="select-order-container">
      <el-form :inline="true" class="search-form">
        <el-form-item label="规格名称">
          <el-input v-model="searchValue" placeholder="请输入规格名称" clearable @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="合同号">
          <el-input v-model="searchContractNo" placeholder="请输入合同号" clearable @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="recordList"
        border
        class="record-table"
        @selection-change="handleSelectionChange"
        style="width: 100%;"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="订单编号" prop="orderNumber"></el-table-column>
        <el-table-column label="合同号" prop="contractNo"></el-table-column>
        <el-table-column label="规格名称" prop="specName"></el-table-column>
        <el-table-column label="锁定数量" prop="orderQuantity"></el-table-column>
        <el-table-column label="已用数量" prop="usedQuantity"></el-table-column>
        <el-table-column label="审核中数量" prop="usedAddQuantity"></el-table-column>
        <el-table-column label="锁定单价(元)" prop="lockedPrice"></el-table-column>
        <el-table-column label="锁定保证金(元)" prop="lockedDeposit"></el-table-column>
        <el-table-column label="今日最大可提数量" prop="maxNum"></el-table-column>
        <el-table-column label="今日剩余可提数量" prop="remainingNum">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.remainingNum <= 0 ? 'red' : '' }">{{ scope.row.remainingNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提货日期" prop="pickupDate"></el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="onSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BigNumber from 'bignumber.js'
export default {
  name: 'SelectOrder',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    salesmanRole: {
      type: String,
      default: ''
    },
    supplierId: {
      type: String,
      default: ''
    },
    isBulkOil: {
      type: String,
      default: ''
    },
    // 新增：外部传入已选中数组
    selectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      recordList: [],
      searchValue: '',
      searchContractNo: '',
      selectedList: [],
      selectedIdSet: new Set()
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.pageNum = 1
        // 弹窗打开时，用父组件传进来的selectList初始化选中
        this.selectedList = [...this.selectList]
        this.selectedIdSet = new Set(this.selectedList.map(item => item.orderId))
        this.getList()
      } else {
        setTimeout(() => {
          this.pageNum = 1
          this.selectedList = []
          this.recordList = []
        }, 500)
      }
    }
  },
  methods: {
    onSearch() {
      this.pageNum = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleSelectionChange(rows) {
      this.selectedList = rows
      this.selectedIdSet = new Set(rows.map(item => item.orderId))
    },
    toggleRowSelection() {
      this.$nextTick(() => {
        const set = this.selectedIdSet
        this.recordList.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, set.has(row.orderId))
        })
      })
    },
    onSubmit() {
      if (!this.selectedList.length) {
        this.$message.error('请选择提货订单')
        return
      }
      this.$emit('confirm', this.selectedList)
      this.handleClose()
    },
    handleClose() {
      this.$emit('close')
    },
    loadRemainingNum(orderId) {
      return this.$axios.get(this.$apis.yxcOrderManage.selectYxcOrderNum, {
        orderId: orderId
      })
    },
    async getList() {
      const userId = this.userId
      const supplierId = this.supplierId
      const res = await this.$axios.get(this.$apis.yxcOrderManage.selectYxcPriceOrderByPage, {
        page: this.pageNum,
        size: this.pageSize,
        supplierId,
        specName: this.searchValue,
        contractNo: this.searchContractNo,
        isBulkOil: this.isBulkOil,
        orderStatus: '2',
        userId,
        orderType: this.orderType
      })
      if (!res) return
      const { list = [], total = 0 } = res || {}
      for (const item of list) {
        const orderQuantity = new BigNumber(item.orderQuantity || 0)
        const usedQuantity = new BigNumber(item.usedQuantity || 0)
        const usedAddQuantity = new BigNumber(item.usedAddQuantity || 0)
        item.remainingNum = orderQuantity.minus(usedQuantity).minus(usedAddQuantity).toString()
        // const data = await this.loadRemainingNum(item.orderId)
        // const val = data || 0
        // item.remainingNum = BigNumber(item.maxNumber).lt(val) ? item.maxNumber : val
      }
      this.recordList = list
      this.total = total || 0
      this.toggleRowSelection()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-order-container {
  max-height: 500px;
  overflow-y: auto;
}

.search-form {
  margin-bottom: 20px;
}

.record-table {
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}
</style>
